import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';
import { EXTENDED_STALE_TIME } from '@/constants/constants';

export const bankAccountQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.bankAccount,
    queryFn: API.me.getBankAccount,
    staleTime: EXTENDED_STALE_TIME,
  });
